import { ReactElement, ReactNode } from "react";
import styled from "styled-components";

export interface TranscriptContainerLayoutProps {
  header: ReactNode;
  content: ReactNode;
  suggestion: ReactNode;
  footer: ReactNode;
  contentRef?: React.RefObject<HTMLDivElement>;
  scrollToBottomButton?: ReactNode;
}

export default function TranscriptContainerLayout({ header, content, suggestion, footer, contentRef, scrollToBottomButton }: TranscriptContainerLayoutProps): ReactElement {
  return (
    <TranscriptContainerLayoutBox id="ctui-transcript-root">
      {
        header &&
        <HeaderBox id="ctui-transcript-header">{header}</HeaderBox>
      }
      <ContentOuterBox id="ctui-transcript-content">
        <ContentScrollBox ref={contentRef}>
          {content}
        </ContentScrollBox>
        {
          scrollToBottomButton &&
          <ScrollToBottomButtonBox>{scrollToBottomButton}</ScrollToBottomButtonBox>
        }
      </ContentOuterBox>
      {
        suggestion &&
        <SuggestionBox id="ctui-transcript-suggestion">{suggestion}</SuggestionBox>
      }
      {
        footer &&
        <FooterBox id="ctui-transcript-footer">{footer}</FooterBox>
      }
    </TranscriptContainerLayoutBox>
  );
}

const TranscriptContainerLayoutBox = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${p => p.theme.paddingXXS}px;
`;

const HeaderBox = styled.div`
  flex: 0 0 auto;
  min-height: 0;

  padding-bottom: ${p => p.theme.paddingXXS}px;
  border-bottom: ${p => p.theme.lineWidth}px ${p => p.theme.lineType} ${p => p.theme.colorBorderSecondary};
`;

const ContentOuterBox = styled.div`
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
`;

const ContentScrollBox = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;

const ScrollToBottomButtonBox = styled.div`
  position: absolute;
  bottom: ${p => p.theme.padding}px;
  left: 50%;
  transform: translateX(-50%);
`;

const SuggestionBox = styled.div`
  flex: 0 0 auto;
  min-height: 0;
`;

const FooterBox = styled.div`
  flex: 0 0 auto;
  min-height: 0;

  padding: ${p => p.theme.paddingXXS}px 0;
  border-top: ${p => p.theme.lineWidth}px ${p => p.theme.lineType} ${p => p.theme.colorBorderSecondary};
`;
